var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowUpSmallIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0820937 3.25889L3.32911 0.0802044C3.40752 -0.0141657 3.54759 -0.0271191 3.64196 0.0512555C3.65246 0.0599892 3.66217 0.0696716 3.67091 0.0802044L6.91792 3.25889C7.02175 3.35512 7.0279 3.51734 6.93166 3.62116C6.88394 3.67265 6.81721 3.70232 6.74701 3.70323H5.20896V7.82182C5.17978 7.99395 5.04056 8.1262 4.86717 8.14654H2.13282C1.99609 8.14654 1.96194 7.97566 1.96194 7.82182V3.70323H0.252974C0.111403 3.70137 -0.00184202 3.58511 2.28882e-05 3.44354C0.000938416 3.37334 0.0306072 3.30662 0.0820937 3.25889Z",
    fill: "#60D394"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.13235 8.65918H4.86669C5.00827 8.65918 5.12305 8.77396 5.12305 8.91553C5.12305 9.0571 5.00827 9.17189 4.86669 9.17189H2.13235C1.99078 9.17189 1.876 9.0571 1.876 8.91553C1.876 8.77396 1.99074 8.65918 2.13235 8.65918Z",
    fill: "#60D394"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.13235 9.68457H4.86669C5.00827 9.68457 5.12305 9.79935 5.12305 9.94092C5.12305 10.0825 5.00827 10.1973 4.86669 10.1973H2.13235C1.99078 10.1973 1.876 10.0825 1.876 9.94092C1.876 9.79935 1.99074 9.68457 2.13235 9.68457Z",
    fill: "#60D394"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.13235 10.71H4.86669C5.00827 10.71 5.12305 10.8247 5.12305 10.9663C5.12305 11.1079 5.00827 11.2227 4.86669 11.2227H2.13235C1.99078 11.2227 1.876 11.1079 1.876 10.9663C1.876 10.8247 1.99074 10.71 2.13235 10.71Z",
    fill: "#60D394"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpSmallIcon);
export default __webpack_public_path__ + "static/media/ArrowUpSmallIcon.577f053f97f3df27343b2737f7cd941d.svg";
export { ForwardRef as ReactComponent };